import { formatDecided, stateMeta } from "@/lib/validationConstants";

/** Inference / Validated / Rejected pill. `row` (optional) adds the decided-by tooltip. */
export default function ValidationBadge({ state, row, testid, className = "" }) {
  const m = stateMeta(state);
  const decided = formatDecided(row);
  const title = [m.hint, decided && `Decided by ${decided}`, row?.validation_note && `Note: ${row.validation_note}`]
    .filter(Boolean).join("\n");
  return (
    <span
      className={`ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border whitespace-nowrap ${className}`}
      style={{ background: m.bg, color: m.fg, borderColor: m.border }}
      title={title}
      data-testid={testid || `validation-badge-${state}`}
      data-state={state}
    >
      {m.label}
    </span>
  );
}
